import styled from 'styled-components'

export const ImageContainer = styled.img`
max-height: 80px;
vertical-align: middle;
`
